export const AppConstants = {
  TOKEN: 'token',
  TOKEN_EXPIRY: 'expirationTime',
  AUTH_HEADER: 'Authorization',
}